export default __webpack_public_path__ + "static/media/Return-Policy.1f86b13a.jpg";